<template>
    <CartCard>
        <div
            class="flex min-h-[58px] w-full cursor-pointer items-center gap-3 px-3 py-2"
            @click="$emit('toggle')"
        >
            <div class="relative flex h-10 w-10 flex-none items-center justify-center rounded-lg bg-primary/10 text-primary">
                <ShoppingBagIcon class="h-5 w-5" />
                <div
                    class="absolute -right-1.5 -top-1.5 flex h-5 min-w-[20px] items-center justify-center rounded-full bg-primary px-1 shadow text-white"
                >
                    <span class="text-[11px] font-black leading-none">{{ count }}</span>
                </div>
            </div>

            <div class="min-w-0 flex-1">
                <p class="text-left text-[11px] font-medium leading-none text-gray-400">
                    購物車
                </p>
                <p class="mt-1 flex items-baseline text-left leading-none text-gray-900">
                    <span class="mr-1 text-[11px] font-bold text-primary">{{ currency }}</span>
                    <span class="text-[18px] font-black tracking-tight">{{
                        amount | number_format
                    }}</span>
                </p>
            </div>

            <button
                type="button"
                class="h-11 flex-none rounded-lg bg-primary px-5 text-sm font-black text-white active:scale-95 disabled:bg-gray-200 disabled:text-gray-500"
                :disabled="!hasItems"
                @click.stop="checkout"
            >
                {{ btnText }}
            </button>
        </div>
    </CartCard>
</template>

<script>
import CartCard from "@/components/cart/CartCard.vue";
import { ShoppingBagIcon } from "@vue-hero-icons/outline";
import { mapGetters } from "vuex";

export default {
    components: { CartCard, ShoppingBagIcon },
    methods: {
        checkout() {
            if (!this.hasItems) return;

            if (this.inCheckoutPage) return $nuxt.$emit("submit-checkout");

            this.$router.push(this.localePath({ name: "order-checkout" }));
        },
    },
    computed: {
        ...mapGetters({
            amount: "cart/amount",
            offer: "cart/offer",
            count: "cart/count",
            hasItems: "cart/hasItems",
            items: "cart/items",
        }),
        atCheckout() {
            return this.$route.name.match("order-checkout");
        },
        btnText() {
            return this.atCheckout ? "確定" : "結算";
        },
        inCheckoutPage() {
            return this.$route.name.match("order-checkout");
        },
    },
};
</script>

<style lang="scss" scoped></style>
